import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

const getPageData = (url) => async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(url, { params });
};

export const getLearners = async (pageNo, pageSize, param) =>
  getPageData(`${baseURL}/learners`)(pageNo, pageSize, param);

export const getAlumni = async (
  paginationParams = {},
  otherParams = {}
) => {
  return await axios.get(`${baseURL}/alumni`, {
    params: {
      ...paginationParams,
      ...otherParams,
    },
  });
};

export const addLearner = async (params) => {
  return await axios.post(`${baseURL}/learner`, params);
};
export const addCredits = async (params) => {
  return await axios.post(`${baseURL}/credits/add`, params);
};
export const removeCredits = async (params) => {
  return await axios.post(`${baseURL}/credits/remove`, params);
};

export const updateLearner = async (id, params) => {
  return await axios.put(`${baseURL}/learner/${id}`, params);
};

export const deleteLearner = async (id) => {
  //Placeholder promise for delete
  return await new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(id);
    }, 1000);
  });
};

export const getLearnersSocialMediaData = async (pageNo, pageSize, param) =>
  getPageData(`${baseURL}/social-media/learners`)(pageNo, pageSize, param);
